import { dom, config, library } from '@fortawesome/fontawesome-svg-core';
import {
  faFacebookF,
  faTwitter,
  faPinterestP,
  faFacebook,
  faInstagram,
  faYoutube,
  faPinterest,
} from '@fortawesome/free-brands-svg-icons';
import {
  faFont,
  faEyeDropper,
  faAngleDown,
  faDownload,
  faPrint,
  faCopy,
  faArrowsAlt,
  faUnlock,
  faPaintRoller,
  faAdjust,
  faObjectGroup,
  faObjectUngroup,
  faTrashAlt,
  faEllipsisV,
  faCheck,
  faTimes,
  faLock,
  faFileExport,
  faSync,
  faPenFancy,
  faProjectDiagram,
  faHandRock,
  faPenNib,
  faPen,
  faBezierCurve,
  faStar,
  faUpload,
  faFileUpload,
  faTrash,
  faEdit,
  faArrowsAltH,
  faArrowsAltV,
  faExchangeAlt,
  faMagic,
  faCrop,
  faChevronLeft,
  faChevronRight,
  faCaretRight,
  faImage,
  faSlidersH,
  faEraser,
  faBold,
  faItalic,
  faAlignCenter,
  faAlignLeft,
  faAlignRight,
  faAlignJustify,
  faUnderline,
  faStrikethrough,
  faTextHeight,
  faListUl,
  faBars,
  faListOl,
  faChevronDown,
  faPlus,
  faMinus,
  faExpand,
  faUndoAlt,
  faRedoAlt,
  faList,
  faSave,
  faEye,
  faShare,
  faShapes,
  faVectorSquare,
  faComment,
  faInfo,
  faQuestion,
  faQuestionCircle,
  faArrowLeft,
  faBriefcase,
  faGlobeAsia,
  faEnvelopeOpenText,
  faBirthdayCake,
  faMailBulk,
  faCaretDown,
  faUser,
  faUsers,
  faSun,
  faFillDrip,
  faUserTimes,
  faPalette,
  faMinusCircle,
  faUndo,
  faRedo,
  faAngleDoubleDown,
  faAngleDoubleUp,
  faAngleUp,
  faMousePointer,
  faSearchPlus,
  faSearchMinus,
  faSyncAlt,
  faCompressArrowsAlt,
  faChevronUp,
  faCog,
  faExpandAlt,
  faRetweet,
  faTh,
  faRulerCombined,
  faFileAlt,
  faChartLine,
  faBan,
  faMask,
  faBorderStyle,
  faToggleOff,
  faToggleOn,
  faLink,
  faPencilAlt,
  faExternalLinkAlt,
  faAngleRight,
} from '@fortawesome/free-solid-svg-icons';
import {
  faStar as farStar,
  faSmileWink,
  faFrown,
  faCopy as farCopy,
  faClone,
  faClipboard,
  faTrashAlt as farTrashAlt,
  faObjectGroup as farObjectGroup,
  faObjectUngroup as farObjectUngroup,
  faFile,
  faStickyNote,
  faSave as farSave,
} from '@fortawesome/free-regular-svg-icons';

export default function registerFaIcons() {
  config.autoAddCss = false;
  library.add(
    faFacebookF,
    faTwitter,
    faPinterestP,
    faFacebook,
    faInstagram,
    faYoutube,
    faPinterest,
    faFont,
    faEyeDropper,
    faAngleDown,
    faDownload,
    faPrint,
    faCopy,
    faClone,
    faArrowsAlt,
    faUnlock,
    faPaintRoller,
    faAdjust,
    faObjectGroup,
    faObjectUngroup,
    faTrashAlt,
    faEllipsisV,
    faCheck,
    faTimes,
    faLock,
    faFileExport,
    faSync,
    faPenFancy,
    faProjectDiagram,
    faHandRock,
    faPenNib,
    faPen,
    faBezierCurve,
    faStar,
    faUpload,
    faFileUpload,
    faTrash,
    faEdit,
    faArrowsAltH,
    faArrowsAltV,
    faExchangeAlt,
    faMagic,
    faCrop,
    faChevronLeft,
    faChevronRight,
    faCaretRight,
    faImage,
    faSlidersH,
    faEraser,
    faBold,
    faItalic,
    faAlignCenter,
    faAlignLeft,
    faAlignRight,
    faAlignJustify,
    faUnderline,
    faStrikethrough,
    faTextHeight,
    faListUl,
    faBars,
    faListOl,
    faChevronDown,
    faPlus,
    faMinus,
    faExpand,
    faUndoAlt,
    faRedoAlt,
    faList,
    faSave,
    farSave,
    faEye,
    faShare,
    faShapes,
    faVectorSquare,
    faComment,
    faInfo,
    faQuestion,
    faQuestionCircle,
    faArrowLeft,
    faBriefcase,
    faGlobeAsia,
    faEnvelopeOpenText,
    faBirthdayCake,
    faMailBulk,
    faCaretDown,
    faUser,
    faUsers,
    faSun,
    faFillDrip,
    faUserTimes,
    faPalette,
    faBan,
    faMinusCircle,
    faUndo,
    faRedo,
    faAngleDoubleDown,
    faAngleDoubleUp,
    faAngleUp,
    farStar,
    faSmileWink,
    faFrown,
    farCopy,
    faClipboard,
    farTrashAlt,
    farObjectGroup,
    farObjectUngroup,
    faFile,
    faStickyNote,
    faMousePointer,
    faSearchPlus,
    faSearchMinus,
    faSyncAlt,
    faCompressArrowsAlt,
    faChevronUp,
    faCog,
    faExpandAlt,
    faRetweet,
    faTh,
    faRulerCombined,
    faFileAlt,
    faChartLine,
    faMask,
    faBorderStyle,
    faToggleOff,
    faToggleOn,
    faLink,
    faPencilAlt,
    faExternalLinkAlt,
    faAngleRight,
  );
  dom.watch();
}
